export default "__VITE_ASSET__CYYBwnFY__"